const moodOptions = [
  {
    value: "VERY_CALM",
    label: "Very Calm",
    image: "/assets/screen2-assets/Emoji_01.webp",
  },
  {
    value: "BETTER",
    label: "Better",
    image: "/assets/screen2-assets/Emoji_02.webp",
  },
  {
    value: "NO_MAJOR_CHANGE",
    label: "No Major Change",
    image: "/assets/screen2-assets/Emoji_03.webp",
  },
  {
    value: "STILL_STRESSED",
    label: "Still Stressed",
    image: "/assets/screen2-assets/Emoji_04.webp",
  },
  {
    value: "WORSE",
    label: "Feeling Worse",
    image: "/assets/screen2-assets/Emoji_05.webp",
  },
];

const ScreenTwo = ({ selectedMood, onMoodChange, onContinue }) => {

  return (
    <section className="screen-two" aria-labelledby="screen-two-title">
      <aside className="screen-two__intro left-side">
        <div className="screen-two__intro-title" aria-hidden="true">
          <strong>How Do You Feel</strong>
          <span>Today?</span>
        </div>
        <img
          className="screen-two__intro-divider"
          src="/assets/screen2-assets/line.webp"
          alt=""
          aria-hidden="true"
        />
        <p>Please select the option that best describes you.</p>
      </aside>

      <div className="content-side">
        <div className="screen-two__main main-content">
        <header className="screen-two__heading">
          <h2 id="screen-two-title">How Do You Feel Today?</h2>
          <p>Please select the option that best describes you.</p>
        </header>

        <fieldset className="mood-grid">
          <legend className="visually-hidden">Select your current mood</legend>
          {moodOptions.map((mood) => {
            const selected = selectedMood === mood.value;

            return (
              <label
                className={`mood-option${selected ? " is-selected" : ""}`}
                key={mood.value}
              >
                <input
                  className="mood-option__input"
                  type="radio"
                  name="mood"
                  value={mood.value}
                  checked={selected}
                  onChange={() => onMoodChange(mood.value)}
                />
                <img src={mood.image} alt="" aria-hidden="true" />
                <span>{mood.label}</span>
                {selected && (
                  <i className="mood-option__check" aria-hidden="true">
                    ✓
                  </i>
                )}
              </label>
            );
          })}
        </fieldset>

        <section
          className="feeling-message"
          aria-label="Every feeling is valid. Every step is progress."
        >
          <img
            className="feeling-message__leaf feeling-message__leaf--left"
            src="/assets/screen1-assets/Leaf_02.webp"
            alt=""
            aria-hidden="true"
          />
          <div>
            <h3>
              Every feeling is valid.
              <span>Every step is progress.</span>
            </h3>
            <img
              className="feeling-message__divider"
              src="/assets/screen2-assets/line.webp"
              alt=""
              aria-hidden="true"
            />
          </div>
          <img
            className="feeling-message__leaf feeling-message__leaf--right"
            src="/assets/screen1-assets/Leaf_01.webp"
            alt=""
            aria-hidden="true"
          />
        </section>

        <input
          className="screen-two__continue"
          type="button"
          name="ui_action"
          value="Continue →"
          onClick={onContinue}
        />

        <p className="screen-two__privacy">
          ▣ &nbsp; Your responses are private and confidential.
        </p>
        </div>
      </div>
    </section>
  );
}

export default ScreenTwo;
